import {
  FormHelperText,
  IconButton,
  List,
  ListItem,
  Paper,
  TextField,
  Typography
} from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import DeleteIcon from '@material-ui/icons/Delete'

import * as R from 'ramda'
import React, { useEffect } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { FrontendSettingForm } from '../../interfaces/setting'

const StyledPaperContainer = styled(Paper)`
  padding: 10px;
  margin: 0px;
`

const StyledFormSubTitle = styled.div`
  margin-left: 15px;
`

// TODO: refactor to perform scroll inside the form
const StyledFormContainer = styled.div`
  overflow-y: auto;
  max-height: 70vh;
`

const StyledFormGroupContainer = styled.div`
  margin: 20px 20% 20px 20%;
`

const StyledFormFieldContainer = styled.div`
  margin: 0px 0px 50px 0px;
  padding: 0px;
`

const StyledLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
`

const StyledLabelContainer = styled.div`
  width: 100%;
  margin-bottom: 15px;
`

const StyledBannerListItemGridContainer = styled.div`
  display: grid;
  grid-template-columns: 45% 45% 10%;
  width: 100%;
  text-align: center;
  margin: 10px 0px;
`

const StyledBannerListItemTextFieldContainer = styled.div`
  padding: 0px 10px;
`

const FormLabel = ({ name }: { name: string }) => (
  <StyledLabelContainer>
    <StyledLabel>{name}</StyledLabel>
  </StyledLabelContainer>
)

const SettingFormMainBody = ({
  frontendSetting
}: {
  frontendSetting: FrontendSettingForm
}) => {
  const { promoBannerImages = [] } = frontendSetting
  const { control, setValue } = useFormContext()
  const textFieldInputProps = { style: { fontSize: 13 } }

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'promoBannerImages'
  })

  // workaround for promoBannerImages not initializing at the beginning
  useEffect(() => {
    setValue('promoBannerImages', promoBannerImages)
  }, [promoBannerImages])

  return (
    <StyledFormContainer>
      <StyledPaperContainer elevation={3}>
        <StyledFormSubTitle>
          <Typography variant="subtitle1">Home Page</Typography>
        </StyledFormSubTitle>
        <StyledFormGroupContainer>
          <StyledFormFieldContainer>
            <FormLabel name="In Season CategoryIds" />
            <FormHelperText>
              Example Input:
              5ff1de1e394600450afab77c,6002c4576cb632a51e68b7b3...
            </FormHelperText>
            <Controller
              name="inSeasonCategoryIds"
              control={control}
              defaultValue={R.pathOr(
                '',
                ['inSeasonCategoryIds'],
                frontendSetting
              )}
              as={
                <TextField
                  id="outlined-required"
                  variant="outlined"
                  defaultValue={R.pathOr(
                    '',
                    ['inSeasonCategoryIds'],
                    frontendSetting
                  )}
                  inputProps={textFieldInputProps}
                  fullWidth
                />
              }
            />
          </StyledFormFieldContainer>
          <StyledFormFieldContainer>
            <FormLabel name="Featured Verified CompanyNos" />
            <FormHelperText>
              Example Input: PROF10000008,PROF10000001...
            </FormHelperText>
            <FormHelperText>
              Company Profile that is not verified will not be included
            </FormHelperText>
            <Controller
              name="featuredVerifiedCompanyNos"
              control={control}
              defaultValue={R.pathOr(
                '',
                ['featuredVerifiedCompanyNos'],
                frontendSetting
              )}
              as={
                <TextField
                  id="outlined-required"
                  variant="outlined"
                  defaultValue={R.pathOr(
                    '',
                    ['featuredVerifiedCompanyNos'],
                    frontendSetting
                  )}
                  inputProps={textFieldInputProps}
                  fullWidth
                />
              }
            />
          </StyledFormFieldContainer>
          <StyledFormFieldContainer>
            <FormLabel name="Promotional Banners" />
            <FormHelperText>
              Note: Empty or Invalid Image Url will not be saved
            </FormHelperText>
            <FormHelperText>Maximum Entry allowed: 5</FormHelperText>
            <List>
              <ListItem
                key="promoBannerImages.headers"
                style={{ padding: '0px' }}
              >
                <StyledBannerListItemGridContainer>
                  <Typography variant="subtitle1">Redirect Url</Typography>
                  <Typography variant="subtitle1">Image Url</Typography>
                </StyledBannerListItemGridContainer>
              </ListItem>
              {fields.map((item, index) => (
                <ListItem key={item.id} style={{ padding: '0px' }}>
                  <StyledBannerListItemGridContainer>
                    <StyledBannerListItemTextFieldContainer>
                      <Controller
                        as={
                          <TextField
                            id="outlined-required"
                            variant="outlined"
                            defaultValue={item.redirectUrl}
                            inputProps={textFieldInputProps}
                            fullWidth
                          />
                        }
                        name={`promoBannerImages[${index}].redirectUrl`}
                        control={control}
                        defaultValue={item.redirectUrl}
                      />
                    </StyledBannerListItemTextFieldContainer>
                    <StyledBannerListItemTextFieldContainer>
                      <Controller
                        as={
                          <TextField
                            id="outlined-required"
                            variant="outlined"
                            defaultValue={item.imageFileUrl}
                            inputProps={textFieldInputProps}
                            fullWidth
                          />
                        }
                        name={`promoBannerImages[${index}].imageFileUrl`}
                        control={control}
                        defaultValue={item.imageFileUrl}
                      />
                    </StyledBannerListItemTextFieldContainer>
                    <IconButton
                      style={{ backgroundColor: 'transparent' }}
                      onClick={() => remove(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </StyledBannerListItemGridContainer>
                </ListItem>
              ))}
            </List>
            <IconButton
              style={{ backgroundColor: 'transparent' }}
              onClick={() => {
                append({ redirectUrl: '', imageFileUrl: '' })
              }}
            >
              <AddCircleOutlineIcon />
            </IconButton>
          </StyledFormFieldContainer>
          <StyledFormFieldContainer>
            <FormLabel name="Bottom Banner Image" />
            <List>
              <ListItem
                key="promoBannerImages.headers"
                style={{ padding: '0px' }}
              >
                <StyledBannerListItemGridContainer>
                  <Typography variant="subtitle1">Redirect Url</Typography>
                  <Typography variant="subtitle1">Image Url</Typography>
                </StyledBannerListItemGridContainer>
              </ListItem>
              <ListItem
                key="bottomBannerImageListItem"
                style={{ padding: '0px' }}
              >
                <StyledBannerListItemGridContainer>
                  <StyledBannerListItemTextFieldContainer>
                    <Controller
                      as={
                        <TextField
                          id="outlined-required"
                          variant="outlined"
                          defaultValue={R.pathOr(
                            '',
                            ['bottomPromoBannerImage', 'redirectUrl'],
                            frontendSetting
                          )}
                          inputProps={textFieldInputProps}
                          fullWidth
                        />
                      }
                      name={'bottomPromoBannerImage.redirectUrl'}
                      control={control}
                      defaultValue={R.pathOr(
                        '',
                        ['bottomPromoBannerImage', 'redirectUrl'],
                        frontendSetting
                      )}
                    />
                  </StyledBannerListItemTextFieldContainer>
                  <StyledBannerListItemTextFieldContainer>
                    <Controller
                      as={
                        <TextField
                          id="outlined-required"
                          variant="outlined"
                          defaultValue={R.pathOr(
                            '',
                            ['bottomPromoBannerImage', 'imageFileUrl'],
                            frontendSetting
                          )}
                          inputProps={textFieldInputProps}
                          fullWidth
                        />
                      }
                      name={'bottomPromoBannerImage.imageFileUrl'}
                      control={control}
                      defaultValue={R.pathOr(
                        '',
                        ['bottomPromoBannerImage', 'imageFileUrl'],
                        frontendSetting
                      )}
                    />
                  </StyledBannerListItemTextFieldContainer>
                </StyledBannerListItemGridContainer>
              </ListItem>
            </List>
          </StyledFormFieldContainer>
        </StyledFormGroupContainer>
      </StyledPaperContainer>
    </StyledFormContainer>
  )
}

export default SettingFormMainBody
